var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12V10H5V12H2ZM5.4 17.55L4 16.1L6.1 14L7.55 15.4L5.4 17.55ZM6.1 8L4 5.9L5.4 4.45L7.55 6.6L6.1 8ZM18 20L13.25 15.25L12 19L9 9L19 12L15.3 13.3L20 18L18 20ZM10 6V3H12V6H10ZM15.9 8L14.45 6.6L16.6 4.45L18 5.85L15.9 8Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSelect);
export default __webpack_public_path__ + "static/media/order_select.981130b71266258f58c3f8f025baf05a.svg";
export { ForwardRef as ReactComponent };